// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1684832624047
      var cssReload = require("/Applications/MAMP/htdocs/obor_live/wp-content/themes/astra-child/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  